import { curry, isEmpty } from 'ramda';
import intersect from 'fast_array_intersect';

/**
 * Checks if any values are contained in items.
 *
 * @param {string} values needles
 * @param {string} items haystack
 * @returns {Boolean} does contain
 */
const hasAny = curry(
  (values: Array<string | number>, items: Array<string | number>) => !isEmpty(intersect([values, items]))
);

export default hasAny;
